/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "../adminShared";
import { PlacementEditor } from "../PlacementEditor";
import { VotingColumnEditor } from "../VotingColumnEditor";

export const VoterSubtitleSection = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, bgVideoBlur, setBgVideoBlur, bgVideoBrightness, setBgVideoBrightness, bgVideoOpacity, setBgVideoOpacity, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, rowBgEvenTranslucent, setRowBgEvenTranslucent, rowBgOddTranslucent, setRowBgOddTranslucent, rowBadgeTranslucent, setRowBadgeTranslucent, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, positionBadgeTranslucent, setPositionBadgeTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, mysteryHiddenPoints, setMysteryHiddenPoints, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    fontTitleItalic, setFontTitleItalic, fontSubtitleItalic, setFontSubtitleItalic, fontCountryItalic, setFontCountryItalic,
    fontPointsItalic, setFontPointsItalic, fontVotingItalic, setFontVotingItalic, fontVotingSecondaryItalic, setFontVotingSecondaryItalic,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12ShowConfetti, setOverlay12ShowConfetti, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  // Convert a hex/rgba color string into a #rrggbb value usable by <input type="color">.
  const toPickerHex = (c) => {
    if (!c || typeof c !== 'string') return "#000000";
    if (c.startsWith('#')) return c.slice(0, 7).padEnd(7, '0');
    const m = c.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map((s) => parseInt(s.trim(), 10));
      const h = (n) => Math.max(0, Math.min(255, isNaN(n) ? 0 : n)).toString(16).padStart(2, '0');
      return `#${h(parts[0])}${h(parts[1])}${h(parts[2])}`;
    }
    return "#000000";
  };
  return (
    <>
                {/* Opciones de visualización del votante */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700" data-testid="voter-display-options">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Panel del Votante</Label>
                  <p className="text-zinc-500 text-sm mb-4">Controla qué elementos se muestran en la columna de votación</p>
                  
                  <div className="space-y-3">
                    {/* Toggle: Borde de foto */}
                    <div className="flex items-center justify-between p-3 bg-zinc-900/50 rounded-lg border border-zinc-700">
                      <div>
                        <Label className="text-zinc-300 font-semibold">Borde bajo la foto del artista</Label>
                        <p className="text-zinc-500 text-xs mt-1">La línea de color que separa la foto del contenido</p>
                      </div>
                      <button
                        type="button"
                        data-testid="toggle-voter-border"
                        onClick={() => setShowVoterBorder(!showVoterBorder)}
                        className={`relative w-14 h-7 rounded-full transition-colors ${showVoterBorder ? 'bg-pink-600' : 'bg-zinc-700'}`}
                      >
                        <div className={`absolute top-0.5 w-6 h-6 bg-white rounded-full transition-transform ${showVoterBorder ? 'translate-x-8' : 'translate-x-1'}`} />
                      </button>
                    </div>

                    {/* Toggle: Badge Jurado */}
                    <div className="flex items-center justify-between p-3 bg-zinc-900/50 rounded-lg border border-zinc-700">
                      <div>
                        <Label className="text-zinc-300 font-semibold">Badge de jurado</Label>
                        <p className="text-zinc-500 text-xs mt-1">Muestra el texto alternativo del jurado (ej: &quot;JURADO OFICIAL&quot;)</p>
                      </div>
                      <button
                        type="button"
                        data-testid="toggle-jury-badge"
                        onClick={() => setShowJuryBadge(!showJuryBadge)}
                        className={`relative w-14 h-7 rounded-full transition-colors ${showJuryBadge ? 'bg-pink-600' : 'bg-zinc-700'}`}
                      >
                        <div className={`absolute top-0.5 w-6 h-6 bg-white rounded-full transition-transform ${showJuryBadge ? 'translate-x-8' : 'translate-x-1'}`} />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Contador Automático en Subtítulo */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700" data-testid="subtitle-counter-section">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Contador Automático en Subtítulo</Label>
                  <p className="text-zinc-500 text-sm mb-4">Muestra automáticamente el número del votante actual (ej: &quot;Jurado Profesional: 3/14&quot;)</p>
                  
                  {/* Toggle: Enable counter */}
                  <div className="flex items-center justify-between mb-4 p-3 bg-zinc-900/50 rounded-lg border border-zinc-700">
                    <div>
                      <Label className="text-zinc-300 font-semibold">Activar contador automático</Label>
                      <p className="text-zinc-500 text-xs mt-1">Sustituye el subtítulo por el contador de fase cuando haya votantes revelados</p>
                    </div>
                    <button
                      type="button"
                      onClick={() => setSubtitleCounterEnabled(!subtitleCounterEnabled)}
                      className={`relative w-14 h-7 rounded-full transition-colors shrink-0 ${
                        subtitleCounterEnabled ? 'bg-pink-600' : 'bg-zinc-700'
                      }`}
                      data-testid="toggle-subtitle-counter"
                    >
                      <span 
                        className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-transform ${
                          subtitleCounterEnabled ? 'translate-x-8' : 'translate-x-1'
                        }`}
                      />
                    </button>
                  </div>

                  {subtitleCounterEnabled && (
                    <div className="space-y-4">
                      {/* Phase order */}
                      <div>
                        <Label className="text-zinc-400 text-sm mb-2 block">Orden de fases</Label>
                        <div className="grid grid-cols-3 gap-2">
                          {[
                            { val: "jury_first", text: "Jurado primero" },
                            { val: "televote_first", text: "Televoto primero" },
                            { val: "all_together", text: "Todo junto" }
                          ].map(({ val, text }) => (
                            <button
                              key={val}
                              type="button"
                              onClick={() => setSubtitlePhaseOrder(val)}
                              className={`p-2.5 rounded-lg border transition-all text-sm ${
                                subtitlePhaseOrder === val
                                  ? 'bg-pink-600 border-pink-500 text-white'
                                  : 'bg-zinc-800 border-zinc-700 text-zinc-300 hover:border-zinc-600'
                              }`}
                              data-testid={`phase-order-${val}`}
                            >
                              {text}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Custom labels */}
                      {subtitlePhaseOrder !== "all_together" && (
                        <div className="grid md:grid-cols-2 gap-4">
                          <div>
                            <Label className="text-zinc-400 text-sm mb-1 block">Texto fase Jurado</Label>
                            <Input
                              value={subtitleJuryLabel}
                              onChange={(e) => setSubtitleJuryLabel(e.target.value)}
                              className="bg-zinc-800 border-zinc-700 text-white"
                              placeholder="Jurado Profesional"
                              data-testid="input-jury-label"
                            />
                          </div>
                          <div>
                            <Label className="text-zinc-400 text-sm mb-1 block">Texto fase Televoto</Label>
                            <Input
                              value={subtitleTelevoteLabel}
                              onChange={(e) => setSubtitleTelevoteLabel(e.target.value)}
                              className="bg-zinc-800 border-zinc-700 text-white"
                              placeholder="Televoto"
                              data-testid="input-televote-label"
                            />
                          </div>
                        </div>
                      )}

                      {/* Info about current counts */}
                      <div className="p-3 bg-zinc-900/60 rounded-lg border border-zinc-600">
                        <p className="text-zinc-400 text-xs mb-2">Conteo actual de participantes:</p>
                        <div className="flex gap-4">
                          <span className="text-cyan-400 text-sm font-semibold">
                            Jurado: {countries.filter(c => c.is_jury).length}
                          </span>
                          <span className="text-pink-400 text-sm font-semibold">
                            Países: {countries.filter(c => !c.is_jury).length}
                          </span>
                        </div>
                        <p className="text-zinc-500 text-xs mt-2">El contador se muestra en el subtítulo del Visualizer cuando reveles votos con &quot;Mostrar&quot;</p>
                      </div>

                      {/* Reset revealed counter */}
                      <Button
                        type="button"
                        onClick={async () => {
                          if (!window.confirm("¿Reiniciar el contador de votantes revelados?")) return;
                          try {
                            await axios.post(`${API}/admin/reset-revealed-voters`);
                            toast.success("Contador reiniciado");
                          } catch (err) {
                            toast.error("Error al reiniciar contador");
                          }
                        }}
                        variant="outline"
                        className="w-full border-amber-600 text-amber-400 hover:bg-amber-900/30"
                        data-testid="btn-reset-revealed"
                      >
                        <RefreshCw className="w-4 h-4 mr-2" />
                        Reiniciar Contador de Revelados
                      </Button>
                    </div>
                  )}
                </div>
    </>
  );
};
